import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { KalgudiButtonModule } from '@kalgudi/common/ui/button';

import { AddAwardsDialogComponent } from './components/add-awards-dialog/add-awards-dialog.component';
import { AddAwardsMobileDialogComponent } from './components/add-awards-mobile-dialog/add-awards-mobile-dialog.component';
import { AddAwardsComponent } from './components/add-awards/add-awards.component';
import { TranslateModule } from '@ngx-translate/core';
import {
  KalgudiAttachUrlModule,
  KalgudiImageChipListModule,
  KalgudiImagePickerModule,
  KalgudiTimePickerModule
} from '@kalgudi/common';
import { MatMenuModule } from '@angular/material/menu';


@NgModule({
  declarations: [
    AddAwardsComponent,
    AddAwardsDialogComponent,
    AddAwardsMobileDialogComponent
  ],
  imports: [
    CommonModule,

    // Forms
    ReactiveFormsModule,

    // Flex module
    FlexLayoutModule,

    // Material modules
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatMenuModule,

    // Kalgudi modules
    KalgudiButtonModule,
    KalgudiAttachUrlModule,
    KalgudiImageChipListModule,
    KalgudiImagePickerModule,
    KalgudiTimePickerModule,
    TranslateModule
  ],
  entryComponents: [
    AddAwardsDialogComponent,
    AddAwardsMobileDialogComponent
  ]
})
export class AwardsModule { }
